import * as React                         from 'react';
import { Route, Switch }                  from 'react-router-dom';
import { AuthWrapper }                    from '@components/AuthWrapper/AuthWrapper';
import { AuthPage }                       from '@modules/auth/pages/AuthPage';
import { DashboardContainer }             from '@modules/dashboard/containers/DashboardContainer';
import { VinDecodeHistoryContainer }      from '@modules/dashboard/containers/VinDecodeHistoryContainer';
import { AccountManagementMainContainer } from '@modules/accountManagement/containers/AccountManagementMainContainer';
import { AuctionsMainContainer }          from '@modules/auctions/containers/AuctionsMainContainer';
import { InvoiceManagementMainContainer } from '@modules/invoiceManagement/InvoiceManagementMainContainer';
import { ManageIntranetUsersContainer }   from '@modules/manageIntranetUsers/ManageIntranetUsersContainer';
import { RegisteredBiddersContainer }     from '@modules/registeredBidders/RegisteredBiddersContainer';
import { NationalAdManagerContainer }     from '@modules/nationalAdManager/NationalAdManagerContainer';

export const routes = (
  <Switch>
    <Route
      exact
      path      = "/dashboard"
      component = {(props: any): JSX.Element => (
        <AuthWrapper>
          <DashboardContainer {...props} />
        </AuthWrapper>
      )}
    />

    <Route
      exact
      path      = "/dashboard/vin-decode-history"
      component = {(props: any): JSX.Element => (
        <AuthWrapper>
          <VinDecodeHistoryContainer {...props} />
        </AuthWrapper>
      )}
    />

    <Route
      exact
      path      = "/account-management/:id?/:page/:subid?/:subpage?"
      component = {(props: any): JSX.Element => (
        <AuthWrapper>
          <AccountManagementMainContainer {...props} />
        </AuthWrapper>
      )}
    />

    <Route
      exact
      path      = "/invoice-management/:id?/:page/:subid?"
      component = {(props: any): JSX.Element => (
        <AuthWrapper>
          <InvoiceManagementMainContainer {...props} />
        </AuthWrapper>
      )}
    />

    <Route
      exact
      path      = "/manage-intranet-users/:id?/:page"
      component = {(props: any): JSX.Element => (
        <AuthWrapper>
          <ManageIntranetUsersContainer {...props} />
        </AuthWrapper>
      )}
    />

    <Route
      exact
      path      = "/registered-bidders/:id?/:page"
      component = {(props: any): JSX.Element => (
        <AuthWrapper>
          <RegisteredBiddersContainer {...props} />
        </AuthWrapper>
      )}
    />

    <Route
      exact
      path      = "/national-ad-manager/:page/:id?/:subpage?"
      component = {(props: any): JSX.Element => (
        <AuthWrapper>
          <NationalAdManagerContainer {...props} />
        </AuthWrapper>
      )}
    />

    <Route
      exact
      path      = "/auctions/:page/:cuid?/:id?"
      component = {(props: any): JSX.Element => (
        <AuthWrapper>
          <AuctionsMainContainer {...props} />
        </AuthWrapper>
      )}
    />

    <Route
      exact
      path      = "/:page?/:recoverId?"
      component = {AuthPage}
    />

    <Route
      path      = "*"
      component = {AuthPage}
    />
  </Switch>
);
